var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.path =='/menu')?_c('v-navigation-drawer',{staticClass:"featureDrawerStyle",attrs:{"temporary":"","fixed":"","right":""},model:{value:(_vm.MywayDrawer),callback:function ($$v) {_vm.MywayDrawer=$$v},expression:"MywayDrawer"}},[_c('div',{staticClass:"drawer-container featuredrawerBackground"},[_c('myway-drawer-myway')],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }